import iconBlack from './pulse_icon_rgb_black.svg';
import iconWhite from './pulse_icon_rgb_white.svg';
import iconRegular from './pulse_icon_rgb_electric-lavender.svg';
import logoBlack from './pulse_logo_rgb_black.svg';
import logoWhite from './pulse_logo_rgb_white.svg';
import logoRegular from './pulse_logo_rgb_electric-lavender.svg';
import styles from './pulse.module.css';
import { Theme, extendTheme } from '../theme-base';
import BanzaiTheme from '../banzai/banzai';

const PulseTheme: Theme = extendTheme(BanzaiTheme, {
  id: 'pulse',
  email: {
    address: 'pulse@banzai.io',
    senderName: 'Banzai Pulse',
  },
  primaryColor: {
    hex: '#707fed',
    rgb: [112, 127, 237],
    hsl: [233, 78, 68],
  },
  publicImages: {
    iconBlack:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/pulse_icon_rgb_black.png',
    iconRegular:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/pulse_icon_rgb_electric-lavender.png',
    iconWhite:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/pulse_icon_rgb_white.png',
    logoBlack:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/pulse_logo_rgb_black.png',
    logoRegular:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/pulse_logo_rgb_electric-lavender.png',
    logoWhite:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/pulse_logo_rgb_white.png',
  },
  iconBlack,
  iconWhite,
  iconRegular,
  iconAlt: 'Pulse icon',
  logoBlack,
  logoWhite,
  logoRegular,
  logoAlt: 'Pulse logo',
  styles,
  productName: 'Pulse',
  login: {
    title: 'Login to excite',
    subTitle: `You are about to make your video content engaging again!`,
    quote: {
      text: `Pulse is amazing.`,
      author: 'Some Dude',
      role: 'Doing something, Some Company',
    },
  },
});

export default PulseTheme;
